// libs
import { History } from 'history'
import * as React from 'react'

// interfaces / constants
import { THUMBNAIL_SIZE_TYPE_MEDIUM } from 'src/components/thumbnail/thumbnail'
import { CLASS_PREFIX } from 'src/constants'
import { ITrackingType } from 'src/high_order_components/with_tracker_props'
import { POST_DISPLAY_MODE_DETAIL } from 'src/interfaces/posts'
import { PostDetailsObjType } from 'src/utils/reporting/events_tracking/events_tracking'

// classes
import Author from 'src/components/post/shared/author/author'
import ShareButton from 'src/components/share/share_button/share_button'
import PremiumContent from 'src/containers/premium_content'
import FollowButton from 'src/containers/smart_components/follow_button/follow_button'

// helpers
import { ContentItemQuery } from '@lopo-tech/lopo-api'
import { FC, useEffect } from 'react'
import { UrlUtils } from 'src/utils/url/url'
import { Comments } from '../shared/comments/comments'
import PostDetailReactionWrapper from '../shared/reactions/post_detail_reaction_wrapper'
import ReactionOverview from '../shared/reactions/reaction_overview/reaction_overview'
import { PostContentBuilder } from './post_content_builder'
import './post_detail.scss'

interface IPostDetails {
  addViewCount: () => void;
  post: NonNullable<ContentItemQuery['contentItem']>;
  history: History;
  tracking?: ITrackingType<PostDetailsObjType>;
}

const cls = CLASS_PREFIX + 'post__detail'

const PostDetails: FC<IPostDetails> = ({ post, tracking, addViewCount }) => {
  const {
    comments,
    publishedAt,
    canComment,
    canShare
  } = post

  const frontendUrl = UrlUtils.detailPage(post.slug, post.__typename)

  useEffect(() => {
    addViewCount()
  }, [])

  return (
    <div className={cls}>
      <article className={cls + '__tile'}>
        <PostContentBuilder post={post} />
        <PremiumContent
          postUrl={frontendUrl}
          canSeeFullContent={post.canSeeFullContent.value}
        />
        <div className={cls + '__tile__footer'}>
          <div className={cls + '__author-more-section'}>
            <Author
              displayMode={POST_DISPLAY_MODE_DETAIL}
              publishedAt={publishedAt}
              size={THUMBNAIL_SIZE_TYPE_MEDIUM}
              author={post.author}
            />
            <FollowButton actorProfile={post.author} />
          </div>
          <ReactionOverview
            displayMode={POST_DISPLAY_MODE_DETAIL}
            basePath={frontendUrl}
            disabled={!post.canReact.value}
            reactions={post.reactions}
          />
          <PostDetailReactionWrapper
            reactableId={post.id}
            reactions={post.reactions}
            canReact={post.canReact.value}
            onClose={() => {}}
          />
          {canShare.value && (
            <div className={cls + '__share-wrapper'}>
              <ShareButton
                tracking={tracking}
                utmSource="post"
                url={frontendUrl}
                title={post.title}
              />
            </div>
          )}
        </div>
        {post.canShowComments.value && (
          <div className={cls + '__footer'}>
            <Comments
              id={post.id}
              canComment={canComment.value}
              isCommentable={post.isCommentable}
              comments={comments?.items || []}
            />
          </div>
        )}
        {/* TODO: Similar content will be added back later: https://mvplabgmbh.slack.com/archives/C094E4CNVJ5/p1757694722078959?thread_ts=1757675194.548769&cid=C094E4CNVJ5 */}
        {/* {similar && <div className={cls + '__related-content-wrapper'}>
          <RelatedContent path={similar}/>
        </div>} */}
      </article>
    </div>
  )
}

export default PostDetails
